function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME GAME

  These are the functions for creating instances of a game, saving, and loading them
  The functions for game initialization and end of game processing are also here

 **********************************************************************************/
var GameGame = /*#__PURE__*/function () {
  function GameGame() {
    _classCallCheck(this, GameGame);
  }
  return _createClass(GameGame, [{
    key: "doesGameExistLocally",
    value:
    /////////////////////////////////////////////////////////////////////
    // Does a game object of this ID exist in our wallet already??
    //
    function doesGameExistLocally(game_id) {
      var _this$app;
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.options) !== null && _this$app !== void 0 && _this$app.games) {
        for (var i = 0; i < this.app.options.games.length; i++) {
          if (this.app.options.games[i].id === game_id) {
            return 1;
          }
        }
      }
      return 0;
    }
  }, {
    key: "removeGameFromOptions",
    value: function removeGameFromOptions() {
      var _this$app$options;
      var game_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (game_id === '') {
        return;
      }
      if ((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && _this$app$options.games) {
        for (var i = 0; i < this.app.options.games.length; i++) {
          if (this.app.options.games[i].id === game_id) {
            this.app.options.games.splice(i, 1);
            i--;
          }
        }
      }
      this.app.storage.saveOptions();
    }

    /**
     * A stub that one player games fill in
     * So we can customize the gameWizard to show "Continue Game" instead of create new game
     * A little complicated if someone starts a chess game then tries to create a second one, so
     * just return 0.
     *
     */
  }, {
    key: "doWeHaveAnOngoingGame",
    value: function doWeHaveAnOngoingGame() {
      return 0;
    }

    /**********************************************************************************
     *  Game Preferences are stored persistently in the wallet,
     *  so you can implement some basic stats tracking across multiple games or
     *  just remember that a player likes to play in "advanced" mode or not
     */
  }, {
    key: "loadGamePreference",
    value: function loadGamePreference(key) {
      if (this.app.options) {
        if (this.app.options.gameprefs) {
          return this.app.options.gameprefs[key];
        }
      }
      return null;
    }
  }, {
    key: "saveGamePreference",
    value: function saveGamePreference(key, value) {
      this.app.options.gameprefs[key] = value;
      this.app.storage.saveOptions();
    }
  }, {
    key: "deleteGamePreference",
    value: function deleteGamePreference(key) {
      if (this.app.options) {
        if (this.app.options.gameprefs) {
          if (this.app.options.gameprefs[key]) {
            delete this.app.options.gameprefs[key];
          }
        }
      }
      return null;
    }

    /****************************************************************************************
     * Creates a new game object for this game module. This object can be JSON-stringified
     * and saved through the wallet (app.options) so that games can persist across browser
     * sessions or other network interruptions
     */
  }, {
    key: "newGame",
    value: function newGame() {
      var game_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      console.info("=========\nCREATING NEW GAME ID: ".concat(game_id, "\n========="));
      if (!game_id) {
        game_id = this.app.crypto.hash(Math.random().toString(32)); //Returns 0.19235734589 format. We never want this to happen!
      }
      var game = {};
      game.id = game_id;
      game.confirms_needed = [];
      game.player = 0;
      game.players = [];
      game.opponents = []; //Is this not redundanct?
      game.keys = [];
      game.players_needed = 1; //For when the Arcade (createGameTXfromOptionsGame)
      game.accepted = []; //Not clear what this was originally for, but is now a master list of players to receive game moves
      game.players_set = 0;
      game.target = 1;
      game.invitation = 1;
      game.initializing = 1;
      game.initialize_game_run = 0;
      game.accept = 0;
      game.over = 0;
      game.winner = 0;
      game.module = '';
      game.originator = '';
      game.timestamp = new Date().getTime();
      game.last_block = 0;
      game.options = {};
      game.options.ver = 1;
      game.invite_sig = '';
      game.recent_moves_cache = []; // recent moves (FIFO for sharing)
      game.future = []; // future moves (arrive while we take action)
      game.lock_interface = 0;
      game.clock = [];
      game.time = {};
      game.time.last_received = 0; //For when we last received control of game
      game.time.last_sent = 0; //For when we send our moves

      game.step = {};
      game.step.game = 0; //Trial to start at 0.
      game.step.players = {}; // associative array mapping pkeys to last game step
      game.step.timestamp = 0; // last_move in observer mode

      game.queue = [];
      game.turn = [];
      game.deck = []; // shuffled cards
      game.pool = []; // pools of revealed cards
      game.dice = this.app.crypto.hash(game_id); //Why not just initialize the dice here?

      game.status = ''; // status message
      game.log = [];
      game.sroll = 0; // secure roll
      game.sroll_hash = '';
      game.sroll_done = 0;
      game.spick_card = ''; // card selected
      game.spick_hash = ''; // secure pick (simulatenous card pick)
      game.spick_done = 0;
      return game;
    }
  }, {
    key: "exportGame",
    value: function exportGame() {
      var g = JSON.parse(JSON.stringify(this.game));
      var pom = document.createElement('a');
      pom.setAttribute('type', 'hidden');
      pom.setAttribute('href', 'data:application/json;utf-8,' + encodeURIComponent(JSON.stringify(g)));
      pom.setAttribute('download', "".concat(this.slug, "-export.json"));
      document.body.appendChild(pom);
      pom.click();
      pom.remove();
    }

    /**
     * Ensures game has .future and .queue as arrays. Does not clear or overwrite existing values.
     */
  }, {
    key: "normalizeGameShape",
    value: function normalizeGameShape(game) {
      if (!game) return;
      if (!Array.isArray(game.future)) game.future = [];
      if (!Array.isArray(game.queue)) game.queue = [];
    }
  }, {
    key: "saveGame",
    value: function saveGame(game_id) {
      if (!this.app.BROWSER) {
        return;
      }
      if (!this.game) {
        console.error('GT: Saving Game Error: safety catch 1');
        return;
      }
      console.debug('--- SAVE GAME --- ');
      if (!this.app.options) {
        this.app.options = {};
      }
      if (!this.app.options.games) {
        this.app.options = Object.assign({
          games: [],
          gameprefs: {
            random: this.app.crypto.generateKeys()
          }
        }, this.app.options);
      }
      if (!game_id || game_id !== this.game.id) {
        //game_id = this.app.crypto.hash(Math.random().toString(32));
        //console.warn(
        //  'GT ERR? Save game with wrong id',
        //  'Parameter: ' + game_id,
        //  'this game.id = ' + this.game.id
        //);
        return;
      }
      if (game_id != null) {
        var _this$app$options2;
        if ((_this$app$options2 = this.app.options) !== null && _this$app$options2 !== void 0 && _this$app$options2.games) {
          for (var i = 0; i < this.app.options.games.length; i++) {
            if (this.app.options.games[i].id === game_id) {
              this.game.timestamp = new Date().getTime();
              this.normalizeGameShape(this.game);
              this.normalizeGameShape(this.app.options.games[i]);

              //
              // sept 25 - do not overwrite any future moves saved separately
              //
              for (var ii = 0; ii < this.app.options.games[i].future.length; ii++) {
                var do_we_contain_this_move = 0;
                for (var iii = 0; iii < this.game.future.length; iii++) {
                  if (this.app.options.games[i].future[ii] === this.game.future[iii]) {
                    do_we_contain_this_move = 1;
                  }
                }
                if (do_we_contain_this_move == 0) {
                  this.game.future.push(this.app.options.games[i].future[ii]);
                }
              }
              console.log('GT [saveGame] before game clone', new Date().toISOString(), Date.now());
              var _gameJson = JSON.stringify(this.game);
              this.app.options.games[i] = JSON.parse(_gameJson);
              console.log('GT [saveGame] after game clone', new Date().toISOString(), Date.now());
              this.app.storage.saveOptions([{
                path: ['games', i],
                json: _gameJson
              }]);
              console.log('GT [saveGame] after saveOptions', new Date().toISOString(), Date.now());
              return;
            }
          }
        }
      }

      //
      // If we didn't find the game (by id) in our wallet
      // add it and save the options

      var gameJson = JSON.stringify(this.game);
      this.app.options.games.push(JSON.parse(gameJson));
      this.app.storage.saveOptions([{
        path: ['games', this.app.options.games.length - 1],
        json: gameJson
      }]);
    }

    /**
     * Will search your wallet for the provided game_id
     * or the most recent game of the type if a game_id is not provided
     *
     * If no game is found, a new game is created, saved, and returned
     *
     * Note: "game" refers to the game object
     */
  }, {
    key: "loadGame",
    value: function loadGame() {
      var game_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      //
      // try to URL specified game
      //
      if (game_id == null) {
        var vars_in_url = this.app.browser.parseHash(window.location.hash);
        if (vars_in_url !== null && vars_in_url !== void 0 && vars_in_url.gid) {
          var _this$app$options3;
          game_id = vars_in_url.gid;
          try {
            game_id = decodeURIComponent(vars_in_url.gid);
          } catch (_) {}
          if (((_this$app$options3 = this.app.options) === null || _this$app$options3 === void 0 || (_this$app$options3 = _this$app$options3.games) === null || _this$app$options3 === void 0 ? void 0 : _this$app$options3.length) > 0) {
            for (var i = 0; i < this.app.options.games.length; i++) {
              if (this.name == this.app.options.games[i].module && this.app.options.games[i].id === game_id) {
                game_id = this.app.options.games[i].id;
                break;
              }
            }
          }
        }
      }

      //
      // try to load most recent game
      //
      if (game_id == null) {
        var _this$app$options4;
        var game_to_open = -1;
        var timeStamp = 0;
        console.info('GT: no game_id, Look for most recent game');
        if (((_this$app$options4 = this.app.options) === null || _this$app$options4 === void 0 || (_this$app$options4 = _this$app$options4.games) === null || _this$app$options4 === void 0 ? void 0 : _this$app$options4.length) > 0) {
          for (var _i = 0; _i < this.app.options.games.length; _i++) {
            //It's not enough to just pull the most recent game,
            //Need to make sure it is the right game module!!
            if (this.name == this.app.options.games[_i].module && this.app.options.games[_i].timestamp > timeStamp) {
              game_to_open = _i;
              timeStamp = this.app.options.games[_i].timestamp;
            }
          }
          if (game_to_open > -1) {
            game_id = this.app.options.games[game_to_open].id;
          }
        }
      }

      //If we were given the game_id or found the most recent valid game, then load it
      if (game_id) {
        for (var _i2 = 0; _i2 < ((_this$app$options5 = this.app.options) === null || _this$app$options5 === void 0 || (_this$app$options5 = _this$app$options5.games) === null || _this$app$options5 === void 0 ? void 0 : _this$app$options5.length); _i2++) {
          var _this$app$options5;
          if (this.app.options.games[_i2].id === game_id) {
            this.game = JSON.parse(JSON.stringify(this.app.options.games[_i2]));
            this.normalizeGameShape(this.game);
            this.clearSnapshots();
            console.info('GT loading game: ' + game_id);
            return this.game;
          }
        }

        //No game to load, must create one
        console.info("GT: [loadGame] create new game with id ".concat(game_id));

        //we don't have a game with game_id stored in app.options.games
        this.game = this.newGame(game_id);
        this.saveGame(this.game.id);
        console.debug('GT [loadGame]: ', JSON.parse(JSON.stringify(this.app.options.games)));
        return this.game;
      }
      return null;
    }

    /*******************************************************************************************************
     *          GAME INITIALIZATION
     *******************************************************************************************************
     *
     * Accept Request is the transaction when all players have agreed to play the game with given options
     * The options and data in tx are processed to create an identical game instance for all players who
     * are given randomized player order (that is consistent despite being run in parallel on different
     * lite clients). Upon successful initialization, the game is saved to the wallet and game queue
     * commands are run. (This is useful for games with card decks that require multiple transactions to
     * encrypt and shuffle a deck)
     *
     */
  }, {
    key: "initializeGameFromAcceptTransaction",
    value: function () {
      var _initializeGameFromAcceptTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(tx) {
        var _txmsg$options;
        var txmsg, game_id, msg_to_verify, i, _i3, players, z, players_reconstructed, _z, zz, _this$game$options, _i4, _i5;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              txmsg = tx.returnMessage();
              game_id = txmsg.game_id; //
              // accepted games should have all the players. If they do not, drop out
              //
              if (!(txmsg.players_needed > txmsg.players.length)) {
                _context.n = 1;
                break;
              }
              console.error('GT [initializeGameFromAcceptTransaction] -- not enough players in accepted transaction.... aborting');
              return _context.a(2, false);
            case 1:
              if (txmsg.players.includes(this.publicKey)) {
                _context.n = 2;
                break;
              }
              console.error('GT [initializeGameFromAcceptTransaction] -- not our game!');
              return _context.a(2, false);
            case 2:
              //
              // NOTE: re-loading the game might throw out some data
              // But this should create the game
              if (!this.game || this.game.id != game_id) {
                if (this.doesGameExistLocally(game_id)) {
                  this.loadGame(game_id);
                } else {
                  this.game = this.newGame(game_id);
                }
              }

              //
              // async game?
              //
              if (txmsg.options.async_dealing == 1) {
                this.async_dealing = 1;
              }
              if ((_txmsg$options = txmsg.options) !== null && _txmsg$options !== void 0 && _txmsg$options.async_dealing) {
                _context.n = 8;
                break;
              }
              console.info('GT: ASYNC DEALING NOT ENABLED');

              //
              // do not re-accept
              if (!(this.game.step.game > 2)) {
                _context.n = 3;
                break;
              }
              console.warn('GT [initializeGameFromAcceptTransaction] -- GAME IN PROGRESS');
              return _context.a(2, false);
            case 3:
              //
              // validate all accept-sigs are proper
              msg_to_verify = 'invite_game_' + txmsg.timestamp;
              if (!(txmsg.players.length == txmsg.players_sigs.length)) {
                _context.n = 7;
                break;
              }
              i = 0;
            case 4:
              if (!(i < txmsg.players.length)) {
                _context.n = 6;
                break;
              }
              if (this.app.crypto.verifyMessage(msg_to_verify, txmsg.players_sigs[i], txmsg.players[i])) {
                _context.n = 5;
                break;
              }
              console.error('GT [initializeGameFromAcceptTransaction] -- PLAYER SIGS do not verify for all players');
              this.halted = 0;
              return _context.a(2, false);
            case 5:
              i++;
              _context.n = 4;
              break;
            case 6:
              _context.n = 8;
              break;
            case 7:
              console.error('GT [initializeGameFromAcceptTransaction] -- Players and player_sigs different lengths!');
              return _context.a(2, false);
            case 8:
              if (!(this.game.over == 1)) {
                _context.n = 9;
                break;
              }
              this.halted = 0;
              console.warn('GT [initializeGameFromAcceptTransaction] -- This game is over, cannot initialize from accept tx');
              return _context.a(2, false);
            case 9:
              //
              // otherwise setup the game
              //
              this.game.options = txmsg.options;
              this.game.module = txmsg.game;
              this.game.originator = txmsg.originator; //Keep track of who initiated the game
              this.game.players_needed = txmsg.players.length; //So arcade renders correctly

              this.gaming_active = 1; //Prevent any moves processing while sorting players

              //
              // add all the players
              //
              for (_i3 = 0; _i3 < txmsg.players.length; _i3++) {
                this.addPlayer(txmsg.players[_i3]);
              }
              this.saveGame(game_id);
              if (!(this.game.players_set == 0)) {
                _context.n = 10;
                break;
              }
              //
              // set our player numbers alphabetically
              //
              players = [];
              for (z = 0; z < this.game.players.length; z++) {
                players.push(this.app.crypto.hash(this.game.players[z] + this.game.id));
              }
              players.sort();
              players_reconstructed = [];
              for (_z = 0; _z < players.length; _z++) {
                for (zz = 0; zz < this.game.players.length; zz++) {
                  if (players[_z] === this.app.crypto.hash(this.game.players[zz] + this.game.id)) {
                    //For async, accepting player goes first!
                    if ((_this$game$options = this.game.options) !== null && _this$game$options !== void 0 && _this$game$options.async_dealing && this.game.players[zz] !== txmsg.originator) {
                      players_reconstructed.unshift(this.game.players[zz]);
                    } else {
                      players_reconstructed.push(this.game.players[zz]);
                    }
                  }
                }
              }
              this.game.players = players_reconstructed;
              for (_i4 = 0; _i4 < this.game.players.length; _i4++) {
                //Figure out which seat is mine
                if (this.game.players[_i4] === this.publicKey) {
                  this.game.player = _i4 + 1;
                }

                // defaults to SAITO keys
                // I guess this is useful for something...
                this.game.keys.push(this.game.players[_i4]);
              }
              //
              // game step
              //
              for (_i5 = 0; _i5 < this.game.players.length; _i5++) {
                this.game.step.players[this.game.players[_i5]] = 0;
              }

              //
              // special key for keystate encryption --> store in game
              //
              this.game.sharekey = this.app.crypto.generateRandomNumber();
              console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!! GAME CREATED !!!\n', '!!!!!!!!!!!!!!!!!!!!');
              console.log('Game Id: ' + game_id);
              console.log('My PublicKey: ' + this.publicKey);
              console.log('My Player Number: ' + this.game.player);
              console.log('ALL KEYS: ' + JSON.stringify(this.game.players));
              console.log('My Share Key: ' + this.game.sharekey);
              console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n');
              this.game.players_set = 1;
              this.saveGame(game_id);

              //
              // players are set and game is accepted, so move into handleGame
              //
              _context.n = 10;
              return this.initializeGameQueue(game_id);
            case 10:
              return _context.a(2, game_id);
          }
        }, _callee, this);
      }));
      function initializeGameFromAcceptTransaction(_x) {
        return _initializeGameFromAcceptTransaction.apply(this, arguments);
      }
      return initializeGameFromAcceptTransaction;
    }()
    /*****************************************************************************************************
     *
     * ****************************               GAME TERMINATION                ************************
     *
     * ***************************************************************************************************
     *
     * There are two ways to end a game:
     * 1) a player sends a "stopgame" request
     * 2) the player(s) send a "gameover" request
     *
     * stopgame may originate in the game through:
     * a) I know I have reached a losing condition based on non-public information
     * b) I choose to forfeit/quit the game through a game module provided UI
     * c) I cancel/forfeit the game through the Arcade or other game invite manager outside the game
     *
     *
     * ****************************************************************************************************/
    /*
    stopgame / gameover transactions bypass the future-move buffer, but they must not
    execute while the engine is halted or mid-queue: they wipe the queue and re-render
    the controls underneath armed UI (e.g. an acknowledge notice with a live shot clock).
    We park them here and drain them via processDeferredGameEndTransactions() when the
    engine resumes (restartQueue / processFutureMoves).
    */
  }, {
    key: "deferGameEndTransactionIfBusy",
    value: function deferGameEndTransactionIfBusy(request, tx) {
      if (this.halted != 1 && this.gaming_active != 1) {
        return false;
      }
      if (!this.deferred_game_end) {
        this.deferred_game_end = [];
      }
      console.warn("GT: deferring ".concat(request, " tx until engine resumes (halted: ").concat(this.halted, ", gaming_active: ").concat(this.gaming_active, ")"));
      this.deferred_game_end.push({
        request: request,
        tx: tx,
        game_id: this.game.id
      });
      return true;
    }
  }, {
    key: "processDeferredGameEndTransactions",
    value: function () {
      var _processDeferredGameEndTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$deferred_game_e;
        var i, _this$deferred_game_e2, request, tx;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if ((_this$deferred_game_e = this.deferred_game_end) !== null && _this$deferred_game_e !== void 0 && _this$deferred_game_e.length) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              i = 0;
            case 2:
              if (!(i < this.deferred_game_end.length)) {
                _context2.n = 6;
                break;
              }
              if (!(this.deferred_game_end[i].game_id === this.game.id)) {
                _context2.n = 5;
                break;
              }
              _this$deferred_game_e2 = this.deferred_game_end[i], request = _this$deferred_game_e2.request, tx = _this$deferred_game_e2.tx;
              this.deferred_game_end.splice(i, 1);
              i--;
              console.info("GT: processing deferred ".concat(request, " tx now that engine has resumed"));
              if (!(request === 'gameover')) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return this.receiveGameOverTransaction(null, tx, 0, this.app);
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.n = 5;
              return this.receiveStopGameTransaction(tx.from[0].publicKey, tx.returnMessage());
            case 5:
              i++;
              _context2.n = 2;
              break;
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function processDeferredGameEndTransactions() {
        return _processDeferredGameEndTransactions.apply(this, arguments);
      }
      return processDeferredGameEndTransactions;
    }()
    /*
    When my game logic shows that I have reached a losing condition and need to notify the opponents
    */
  }, {
    key: "sendStopGameTransaction",
    value: function () {
      var _sendStopGameTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$game;
        var reason,
          newtx,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              reason = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'forfeit';
              _context3.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context3.v;
              this.game.accepted.forEach(function (player) {
                newtx.addTo(player);
              });
              newtx.msg = {
                request: 'stopgame',
                game_id: this.game.id,
                module: this.game.module,
                reason: reason,
                step: (_this$game = this.game) === null || _this$game === void 0 || (_this$game = _this$game.step) === null || _this$game === void 0 ? void 0 : _this$game.game,
                deck: this.game.deck
              };
              _context3.n = 2;
              return newtx.sign();
            case 2:
              //Send message
              this.app.network.propagateTransaction(newtx);
              this.app.connection.emit('relay-send-message', {
                recipient: this.game.accepted,
                request: 'game relay update',
                data: newtx.toJson()
              });
              //Send message into the ether so that the arcade service can update the game status to "over"
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: newtx.toJson()
              });
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function sendStopGameTransaction() {
        return _sendStopGameTransaction.apply(this, arguments);
      }
      return sendStopGameTransaction;
    }()
    /*
    We receive a transaction (on/off chain) saying that a player hit the quit button
    We figure out who the other players are and if the game has gone beyond its grace period,
    call another function to push us into end game state (which requires another transaction)
    */
  }, {
    key: "receiveStopGameTransaction",
    value: function () {
      var _receiveStopGameTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(resigning_player, txmsg) {
        var _this$game2;
        var i, winners, _iterator, _step, p;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              console.info('GT [receiveStopGame] : ' + resigning_player, txmsg);
              this.game.queue = [];
              this.moves = [];

              //Prevents double processing (from on/off chain)
              if (!(this.game.over == 1 || this.game.terminating)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!((_this$game2 = this.game) !== null && _this$game2 !== void 0 && _this$game2.players)) {
                _context4.n = 2;
                break;
              }
              if (this.game.players.includes(resigning_player)) {
                _context4.n = 2;
                break;
              }
              //Player already not an active player, make sure they are also removed from accepted to stop receiving messages
              for (i = this.game.accepted.length; i >= 0; i--) {
                if (this.game.accepted[i] == resigning_player) {
                  this.game.accepted.splice(i, 1);
                }
              }
              return _context4.a(2, 0);
            case 2:
              if (!(this.game.players.length == 1)) {
                _context4.n = 3;
                break;
              }
              this.game.over = 1;
              this.saveGame(this.game.id);
              return _context4.a(2);
            case 3:
              this.saveGame(this.game.id);
              winners = [];
              if (txmsg.reason == 'cancellation') {
                if (resigning_player == this.publicKey) {
                  siteMessage("".concat(this.name, " game cancelled"), 5000);
                } else {
                  this.updateLog("".concat(this.app.keychain.returnUsername(resigning_player), " cancels the game, no one wins"));
                  siteMessage("".concat(this.app.keychain.returnUsername(resigning_player), " cancels the game, no one wins"), 8000);
                }
              } else {
                _iterator = _createForOfIteratorHelper(this.game.players);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    p = _step.value;
                    if (p !== resigning_player) {
                      winners.push(p);
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              _context4.n = 4;
              return this.triggerGameOver(winners, txmsg.reason);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function receiveStopGameTransaction(_x2, _x3) {
        return _receiveStopGameTransaction.apply(this, arguments);
      }
      return receiveStopGameTransaction;
    }() //
    // Discard pending gameplay queue commands and append the terminal protocol.
    // Preserves any SEND/RECEIVE instructions already queued (e.g. table debt).
    // Because the queue is LIFO, unshift GAMEOVER (runs last) and push SETTLE
    // (runs first) so execution order is SETTLE -> settlement payments -> GAMEOVER.
    //
  }, {
    key: "enqueueTerminalQueueProtocol",
    value: function enqueueTerminalQueueProtocol() {
      if (this.game.terminating) {
        return;
      }
      this.game.terminating = 1;
      var payments = this.game.queue.filter(function (q) {
        return typeof q === 'string' && (q.startsWith('SEND\t') || q.startsWith('RECEIVE\t'));
      });
      this.game.queue = payments;
      this.game.queue.unshift('GAMEOVER');
      this.game.queue.push('SETTLE');
    }
  }, {
    key: "triggerGameOver",
    value: function () {
      var _triggerGameOver = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var winner,
          reason,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              winner = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : [];
              reason = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
              if (!(this.game.over == 1 || this.game.terminating)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              this.game.winner = winner;
              this.game.reason = reason;
              this.game.canProcess = true;
              this.enqueueTerminalQueueProtocol();
              _context5.n = 2;
              return this.sendGameOverTransaction(winner, reason);
            case 2:
              if (this.gaming_active) {
                _context5.n = 3;
                break;
              }
              _context5.n = 3;
              return this.restartQueue();
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function triggerGameOver() {
        return _triggerGameOver.apply(this, arguments);
      }
      return triggerGameOver;
    }()
    /*
      Typically run by all the players, so we filter to make sure just one player sends to transaction
      Can also be used by a player (A) to announce to opponents that A is the winner.
      Function selects a winner to generate the game ending transaction, which is processed above
      in receiveGameOverTransaction
      */
  }, {
    key: "sendGameOverTransaction",
    value: function () {
      var _sendGameOverTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this$game3, _this$game$options2;
        var winner,
          reason,
          player_to_send,
          newtx,
          game_id,
          slug,
          link,
          _this$game4,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              winner = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : [];
              reason = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : '';
              console.info('GT: End Game! Winner:', winner);
              player_to_send = Array.isArray(winner) ? winner[0] : winner;
              player_to_send = player_to_send || this.game.players[0];
              this.game.canProcess = true;
              if (!this.gameOverCallback) {
                _context6.n = 1;
                break;
              }
              console.info('GT: Not sending gameover transaction because already received. Process now!');
              this.gameOverCallback();
              return _context6.a(2, null);
            case 1:
              if (!(this.game.over == 1 || this.game.gameover_sent)) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, null);
            case 2:
              _context6.n = 3;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 3:
              newtx = _context6.v;
              this.game.accepted.forEach(function (player) {
                newtx.addTo(player);
              });
              game_id = this.game.id;
              slug = typeof this.returnSlug === 'function' ? this.returnSlug() : this.name;
              link = window.location.origin + "/arcade/?game=".concat(encodeURIComponent(slug), "&game_id=").concat(encodeURIComponent(game_id));
              newtx.msg = {
                request: 'gameover',
                game_id: this.game.id,
                winner: winner,
                players: this.game.players.join('_'),
                module: this.game.module,
                reason: reason,
                link: link,
                options: this.game.options,
                step: (_this$game3 = this.game) === null || _this$game3 === void 0 || (_this$game3 = _this$game3.step) === null || _this$game3 === void 0 ? void 0 : _this$game3.game,
                timestamp: new Date().getTime()
              };
              if ((_this$game$options2 = this.game.options) !== null && _this$game$options2 !== void 0 && _this$game$options2.league_id) {
                newtx.msg.league_id = (_this$game4 = this.game) === null || _this$game4 === void 0 || (_this$game4 = _this$game4.options) === null || _this$game4 === void 0 ? void 0 : _this$game4.league_id;
              }
              _context6.n = 4;
              return newtx.sign();
            case 4:
              if (!(player_to_send == this.publicKey)) {
                _context6.n = 5;
                break;
              }
              console.info('GT: I send gameover tx');

              //Send message
              this.app.network.propagateTransaction(newtx);

              //Send message to other players (or observers) so they can process the gameover code
              this.app.connection.emit('relay-send-message', {
                recipient: this.game.accepted,
                request: 'game relay update',
                data: newtx.toJson()
              });
              //Send message into the ether so that the arcade service can update the game status to "over"
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: newtx.toJson()
              });
              this.game.gameover_sent = 1;
              this.saveGame(this.game.id);
              return _context6.a(2, 0);
            case 5:
              return _context6.a(2, newtx);
          }
        }, _callee6, this);
      }));
      function sendGameOverTransaction() {
        return _sendGameOverTransaction.apply(this, arguments);
      }
      return sendGameOverTransaction;
    }()
    /*
    Process receipt of a transaction announcing end-of-game
    Updates the internal game status and through UI notifies all players that the game is over
    For convenience, a displayed <div id="status"> on the game page acquires a button to return player to the arcade
    If elsewhere on the site, uses sitemessage to announce end of game
    If crypto is staked on the game, launches a settlement interface
    */
  }, {
    key: "receiveGameOverTransaction",
    value: function () {
      var _receiveGameOverTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(blk, tx, conf, app) {
        var _this$game5,
          _this = this;
        var txmsg, game_id, winner, reason;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              txmsg = tx.returnMessage();
              game_id = txmsg.game_id, winner = txmsg.winner, reason = txmsg.reason;
              console.info('GT: Received Gameover Request from ' + tx.from[0].publicKey, JSON.parse(JSON.stringify(this.game.players)));

              //
              // sender must be in game to end it (removed players no problem)
              // Make sure this is only processed once
              //
              if (!(!this.game.players.includes(tx.from[0].publicKey) || this.game.over == 1)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              if (!(this.game.over == 0 && ((_this$game5 = this.game) === null || _this$game5 === void 0 ? void 0 : _this$game5.canProcess) == false)) {
                _context7.n = 2;
                break;
              }
              this.gameOverCallback = function () {
                _this.receiveGameOverTransaction(blk, tx, conf, app);
              };
              console.warn('GT: Received Gameover Transaction before we were ready... move into callback');
              console.debug(this.game.over, this.game.canProcess, this.game.queue);
              return _context7.a(2);
            case 2:
              this.gameOverCallback = null;
              if (this.game.terminating) {
                _context7.n = 4;
                break;
              }
              this.game.winner = winner;
              this.game.reason = reason;
              this.game.canProcess = true;
              this.enqueueTerminalQueueProtocol();
              this.saveGame(this.game.id);
              _context7.n = 3;
              return this.restartQueue();
            case 3:
              _context7.n = 5;
              break;
            case 4:
              if (winner && (!this.game.winner || Array.isArray(this.game.winner) && this.game.winner.length === 0)) {
                this.game.winner = winner;
                this.game.reason = reason;
                this.saveGame(this.game.id);
              }
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function receiveGameOverTransaction(_x4, _x5, _x6, _x7) {
        return _receiveGameOverTransaction.apply(this, arguments);
      }
      return receiveGameOverTransaction;
    }()
  }]);
}();
module.exports = GameGame;